export default "__VITE_PUBLIC_ASSET__c799eeef__"